( function( $ ) {
    "use strict";

    var UserPersonPermissionSet = {};

    UserPersonPermissionSet.onChangeCalendarRead = function() {
        var $calendarReadCheckbox = $(this),
            $formEntry = $calendarReadCheckbox.closest('[data-form-entry="person-permission-set"]'),
            $calendarWriteCheckbox = $formEntry.find('[data-form-control="calendar-write"]');

        if ($calendarReadCheckbox.prop('checked') && $calendarWriteCheckbox.prop('checked')) {
            $calendarWriteCheckbox.prop('checked', false);
        }
    };

    UserPersonPermissionSet.onChangeCalendarWrite = function() {
        var $calendarWriteCheckbox = $(this),
            $formEntry = $calendarWriteCheckbox.closest('[data-form-entry="person-permission-set"]'),
            $calendarReadCheckbox = $formEntry.find('[data-form-control="calendar-read"]');

        if ($calendarWriteCheckbox.prop('checked') && $calendarReadCheckbox.prop('checked')) {
            $calendarReadCheckbox.prop('checked', false);
        }
    };

    var $body = $('body');

    $body.on('app.init', function(ev) {
        var $container = $(ev.container),
            $formEntries = $container.find('form [data-form-entry="person-permission-set"]'),
            $calendarReadCheckboxes = $formEntries.find('[data-form-control="calendar-read"]'),
            $calendarWriteCheckboxes = $formEntries.find('[data-form-control="calendar-write"]');

        $calendarReadCheckboxes
            .on('change', UserPersonPermissionSet.onChangeCalendarRead)
        ;

        $calendarWriteCheckboxes
            .on('change', UserPersonPermissionSet.onChangeCalendarWrite)
        ;
    });

}( jQuery ));